import script from "./menu-bar.vue?vue&type=script&setup=true&lang=js"
export * from "./menu-bar.vue?vue&type=script&setup=true&lang=js"

import "./menu-bar.vue?vue&type=style&index=0&id=5ddf18d5&lang=scss&scoped=true"

import exportComponent from "/builds/frontend/linjie/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5ddf18d5"]])

export default __exports__